import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  col: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  row: {
    display: 'flex',
    flex: 1,
  },

  form: {
    display: 'flex',
    flex: 1,
  },
})

export default useStyles
